<template>
  <Layout class="g-wrapper g-vertical-block">
    <div class="c-projectgroup g-main-wrapper">
      <project-group-filter placeholder="请输入项目组ID或者名称" @on-add="projectGroupEdit" @on-refresh="getData" />
      <!-- table -->

      <Viewport v-model="tableHeight">
        <project-group-table
          :loading="loading"
          :data="tableList"
          :height="tableHeight"
          :columns="tableCol"
          @on-edit="projectGroupEdit"
          @on-game="projectGroupGameEdit"
        />
      </Viewport>
    </div>

    <!-- 新增/编辑项目组弹窗 -->
    <project-group-set
      ref="projectGroupSetRef"
      v-model="model"
      title="项目组"
      :opData="opData"
      :edit="edit"
      :loading="loading"
      @on-ok="createOrSave"
    >
      <template #remove>
        <el-button v-if="edit" @click="deleteProjectGroup">删除项目组</el-button>
      </template>
    </project-group-set>

    <!-- 新增/编辑项目组游戏弹窗 -->
    <project-group-game-set
      v-model="gameModal"
      title="游戏选择"
      :data="gameData"
      :gameIds="gameIds"
      :edit="edit"
      :loading="loading"
      :asyning="asyning"
      @on-ok="gameSet"
    />
  </Layout>
</template>
<script>
import mixin from '../mixins/mixin'
import columns from '../data/project_group_manager_column'
import { isArray } from '@/common/js/utils'
import {
  queryAllProjectGroup,
  queryProjectGroupById,
  queryAllPtomStaff,
  addOrEditProjectGroup,
  editProjectGroupGame,
  queryAllGameByCondition
} from '@/api/sysmana.model'
import ProjectGroupFilter from './components/project-group-filter.vue'
import ProjectGroupTable from './components/project-group-table.vue'
import ProjectGroupSet from './components/project-group-set.vue'
import ProjectGroupGameSet from './components/project-group-game-set.vue'

export default {
  name: 'ProjectGroupManeger',
  mixins: [mixin],
  components: { ProjectGroupFilter, ProjectGroupTable, ProjectGroupSet, ProjectGroupGameSet },
  methods: {
    getData(filter) {
      let params = {}
      if (filter) params = Object.assign(params, filter)
      this.params = JSON.parse(JSON.stringify(params))
      // 加载状态
      this.loading = true
      queryAllProjectGroup(params)
        .then((data) => {
          this.loading = false
          if (!data) return
          if (isArray(data)) {
            this.tableList = data
          }
        })
        .catch((err) => {
          this.$Message.error({
            duration: 5,
            content: err
          })
        })
    },
    projectGroupEdit(edit) {
      this.edit = !!edit
      if (edit) {
        const { id } = edit
        this.loading = true
        queryProjectGroupById({ id }).then((data) => {
          this.loading = false
          if (data) {
            const { id, name, manageIds, opIds } = data
            this.info = { id, name, manageIds, opIds }

            this.model = true
            this.$nextTick(() => {
              this.$refs.projectGroupSetRef.setForm(this.info)
            })
          }
        })
      } else {
        this.info = { id: '', name: '', manageIds: [], opIds: [] }
        this.model = true
      }
    },
    createOrSave(info) {
      if (info.id && info.id > 0) {
        // 编辑
        info.status = 2
      } else {
        // 新增
        info.status = 1
      }
      this.loading = true
      addOrEditProjectGroup(info).then((data) => {
        this.loading = false
        if (data) {
          this.$Message.success('操作成功')
          this.model = false
          this.getData()
        } else {
          this.$Message.error('操作失败')
        }
      })
    },
    deleteProjectGroup() {
      this.$confirm('删除将不可以恢复，相应绑定的数据报表将丢失，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true
          addOrEditProjectGroup({ ...this.info, status: 0 }).then((data) => {
            this.loading = false
            if (data) {
              this.$Message.success('删除成功')
              this.model = false
              this.getData()
            } else {
              this.$Message.error('删除失败')
            }
          })
        })
        .catch(() => {})
    },
    wrapGameData(gameData) {
      return gameData.map((ret) => {
        return {
          id: ret.gameId,
          value: ret.gameName,
          name: ret.gameName,
          gameGroupIds: ret.groupGameIds,
          midGameId: ret.middlewareGameId
        }
      })
    },
    projectGroupGameEdit(edit) {
      this.loading = true
      queryAllGameByCondition().then((data) => {
        if (data) {
          this.gameData = this.wrapGameData(data)
          this.queryProjectGroupInfo(edit)
        }
      })
    },
    queryProjectGroupInfo(edit) {
      const { id } = edit
      queryProjectGroupById({ id }).then((data) => {
        this.loading = false
        if (data) {
          const { id, gameIds } = data
          this.gameGroupId = id
          this.gameIds = gameIds
          this.gameModal = true
        }
      })
    },
    gameSet(info) {
      const params = {
        id: this.gameGroupId,
        gameIds: info.map((ret) => ret.id)
      }
      this.asyning = true
      editProjectGroupGame(params).then((data) => {
        this.asyning = false
        if (data) {
          this.$Message.success('操作成功')
          this.getData()
          this.gameModal = false
        }
      })
    },
    preload() {
      Promise.all([queryAllPtomStaff()])
        .then((data) => {
          const [opData] = data
          if (opData && isArray(opData.rows)) {
            this.opData = opData.rows.map((ret) => {
              return {
                id: ret.opId,
                name: ret.name
              }
            })
          } else {
            this.$Message.error('返回数据结构错误！')
          }
        })
        .catch((err) => {
          console.log(err)
        })
    }
  },
  data() {
    return {
      model: false, // 项目组弹窗开关
      gameModal: false, // 游戏弹窗开关
      asyning: false, // 设置状态
      edit: null,
      gameGroupId: '',
      tableHeight: 330,
      info: {},
      gameIds: [],
      opData: [],
      gameData: []
    }
  },
  created() {
    this.tableCol = columns
    this.preload()
    this.getData()
  }
}
</script>
<style lang="scss" scoped>
.c-projectgroup {
  padding-top: 8px;
}
</style>
